import React from 'react';
import { Switch } from 'react-router-dom';
import RouteWrapper from '../../RouteWrapper';
import UnifiedSearch from '../../FlightSearch/components/children/UnifiedSearch/UnifiedSearch';
import AdvancedSearch from './Search/children/AdvancedSearch/AdvancedSearch';

export default componentProps => (
  <Switch>
    <RouteWrapper
      path='/flight-tracker/search'
      name='UnifiedSearch'
      exact
      allowSitemap
      component={props => (
        <UnifiedSearch
          {...props}
          {...componentProps}
        />
      )}
    />
    <RouteWrapper
      path='/flight-tracker/search/advanced'
      name='AdvancedSearch'
      exact
      allowSitemap
      component={props => (
        <AdvancedSearch
          {...props}
          {...componentProps}
        />
      )}
    />
  </Switch>
);



// WEBPACK FOOTER //
// ./modules/FlightTracker/components/routes.js